import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';

import { saveAs } from 'file-saver';
/*
  Generated class for the ContasBancariasService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ContabilidadeService {
    urlObterQuestoes: string;
    codigoModuloContabilidade = 4;
    analiseAtual: any = null;
    idPaginaContabilidade: string = "954";
    resumoAnalise: any;

  constructor(http: HttpClient,
    private gestaoPcaService: GestaoPcaService,
    private utilService: UtilService) {
  }

  public obterIdPaginaContabilidade () {
    return this.idPaginaContabilidade;
  }

  //Obter dados da análise horizontal do balanço patrimonial
  public obterBalancoPatrimonialDaAnaliseHorizontal(): Observable<any> {
    this.urlObterQuestoes = "ADCAnaliseHorizontal/balancoPatrimonial?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  //Obter dados da análise horizontal do balanço patrimonial
  public obterBalancoDvpDaAnaliseHorizontal(): Observable<any> {
    this.urlObterQuestoes = "ADCAnaliseHorizontal/balancoDvp?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  //Obter dados da análise vertical do balanço patrimonial
  public obterAnaliseVertical(): Observable<any> {
    this.urlObterQuestoes = "ADCAnaliseVertical/balancoPatrimonial?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterListaAnalises(): Observable<any> {
    this.urlObterQuestoes = "conta/listarAnalises?idPca=" + this.gestaoPcaService.getPCA().id  + "&isAnalista=" + true;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterListaAnalisesJur(): Observable<any> {
    this.urlObterQuestoes = "conta/listarAnalises?idPca=" + this.gestaoPcaService.getPCA().id + "&isAnalista=" + false;
    return this.utilService.getJSON(this.urlObterQuestoes);
}

  public obterDadosAnalisePorModulo(codigoAnalise): Observable<any> {
    this.urlObterQuestoes = "ADCAnalise/obterPorModuloAnalise/" + codigoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterDadosAnalisePorTipo(idSecaoPagina): Observable<any> {
    this.urlObterQuestoes = "ADCAnalise/obterPorTipoAnalise/" + idSecaoPagina + "?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarIncluirAnalise(codigoAnalise, dadosAnalise) {
    this.urlObterQuestoes = "ADCAnalise/" + codigoAnalise + "/atualizaCertificado";
    return this.utilService.putJSON(this.urlObterQuestoes, dadosAnalise);
  }

  public submeterAnaliseNoCertificado(codigoAnalise, dadosAnalise) {
    this.urlObterQuestoes = "ADCAnalise/" + codigoAnalise + "/submeterCertificado";
    return this.utilService.putJSON(this.urlObterQuestoes, dadosAnalise);
  }


  // public getContaModel() {
  //   let novaConta = new ContaBancaria();
  //   novaConta.idPca = this.gestaoPcaService.getPCA().id;
  //   return novaConta;
  // }

  public listarTiposConta(): Observable<any> {
    this.urlObterQuestoes = "tipoConta/listar";
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public listarBancos(): Observable<any> {
    this.urlObterQuestoes = "banco/listar";
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public listarDiferencas(): Observable<any> {
    this.urlObterQuestoes = "fonteDiferenca/listar";
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarNovaConta(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "conta/salvar";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public downloadTemplateContasMassa() {
    let path = "conta/downloadTemplateImportacao";
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON(path)
      .subscribe(data => {
        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, "Template_importação_contas_em_massa.xlsx");
      },
      error => console.log("Error downloading the file. error: " + error));
  }

  public listarContas(): Observable<any> {
    this.urlObterQuestoes = "conta/listarPorPca/" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public removerConta(idConta): Observable<any> {
    this.urlObterQuestoes = "conta/deletar/" + idConta;
    return this.utilService.deleteJSON(this.urlObterQuestoes);
  }

  public listarArquivos(conta): Observable<any> {
    let urlObtencaoDados: string = "arquivoConta/listar/" + conta.idConta;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarArquivo(event, conta) {

    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();

      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "arquivoConta/salvar/" + conta.idConta;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public salvarContaEmMassa(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('xlsContas', file, file.name);
      let envioRolXml: string = "conta/importarContas?idPca=" + this.gestaoPcaService.getPCA().id;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public downloadfile(arquivo: any) {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON("arquivoConta/download/" + arquivo.idArquivoConta)
      .subscribe(data => {
        // if (data.length <= 0) {
        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, arquivo.nmArquivo);
        // }else{
        // }
      },
      error => console.log("Error downloading the file. error: " + error));
  }

  public deletarArquivo(arquivo): Observable<any> {
    let urlObtencaoDados: string = "arquivoConta/deletar/" + arquivo.idArquivoConta;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }
}



// WEBPACK FOOTER //
// ./src/providers/contabilidade-service.ts